<template>
    <div class="date-card">
      <div class="card-item" @click="selectDate('day')">日</div>
      <div class="card-item" @click="selectDate('threeDay')">三日</div>
      <div class="card-item" @click="selectDate('week')">周</div>
      <div class="card-item" @click="selectDate('month')">月</div>
      <div class="card-item" @click="selectDate('year')">年</div>
    </div>
</template>

<script>
    export default {
        name: "CheckDate",
        data(){
          return{

          }
        },
        methods: {
          selectDate(data){
            this.$emit("getDate", data);
          }
        }
    }
</script>

<style scoped>
  .date-card{
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .card-item{
    width: 20%;
    cursor: pointer;
    text-align: center;
    margin: 5px 0;
    font-size: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/views/datav/CheckDate.vue